import { defineMessages } from 'react-intl';

export const imageGalleryMessages = defineMessages({
  zoom: {
    id: 'imageGallery.zoom',
    defaultMessage: 'Bild zoomen',
  },
  ariaNextImage: {
    id: 'imageGallery.aria.nextImage',
    defaultMessage: 'weitere Bilder rechts',
  },
  ariaPrevImage: {
    id: 'imageGallery.aria.prevImage',
    defaultMessage: 'weitere Bilder links',
  },
});
